import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.for-each";
import "core-js/modules/web.dom-collections.for-each";
import { __awaiter, __generator, __read, __spread } from "tslib";
import Vue from 'vue';
var m = {
  namespaced: true,
  state: function state() {
    return {
      activityList: {
        list: [],
        loaded: false,
        req: false
      },
      commonBadges: {
        list: [],
        count: 0
      },
      finalMedals: {
        list: [],
        count: 0
      },
      fragmentBadges: {
        list: [],
        count: 0
      },
      holidayMedals: {
        list: [],
        count: 0
      },
      activityBadges: {},
      badgeDetails: {},
      lightBagesCount: 0,
      myData: {
        requesting: false,
        loaded: false,
        list: []
      },
      received: {},
      today: null
    };
  },
  mutations: {
    concatActivityList: function concatActivityList(state, _a) {
      var key = _a.key,
          list = _a.list;
      state.activityList.list = state.activityList.list.concat(list);
    },
    setActivityListLoaded: function setActivityListLoaded(state, _a) {
      var key = _a.key,
          loaded = _a.loaded;
      state.activityList.loaded = loaded;
    },
    setActivityListReq: function setActivityListReq(state, _a) {
      var key = _a.key,
          req = _a.req;
      state.activityList.req = req;
    },
    setCommonBadges: function setCommonBadges(state, list) {
      var count = 0;
      list.forEach(function (item) {
        (item.medals || []).forEach(function (item) {
          if (item.received) {
            count++;
          }
        });
        item.unfold = false;
      });
      Vue.set(state.commonBadges, 'list', list);
      Vue.set(state.commonBadges, 'count', count);
    },
    setFragmentBadges: function setFragmentBadges(state, list) {
      var count = 0;
      list.forEach(function (item) {
        (item.medals || []).forEach(function (item) {
          if (item.received) {
            count++;
          }
        });
        item.unfold = false;
      });
      Vue.set(state.fragmentBadges, 'list', list);
      Vue.set(state.fragmentBadges, 'count', count);
    },
    setHolidayMedals: function setHolidayMedals(state, list) {
      var count = 0;
      list.forEach(function (item) {
        (item.medals || []).forEach(function (item) {
          if (item.received) {
            count++;
          }
        });
        item.unfold = false;
      });
      Vue.set(state.holidayMedals, 'list', list);
      Vue.set(state.holidayMedals, 'count', count);
    },
    setFinalMedal: function setFinalMedal(state, list) {
      // let count: number = 0;
      // list.forEach((item) => {
      //     count++;
      //     // (item.medals || []).forEach((item) => {
      //     //     if (item.received) {
      //     //         count ++;
      //     //     }
      //     // });
      //     // item.unfold = false;
      // });
      Vue.set(state.finalMedals, 'list', list);
      Vue.set(state.finalMedals, 'count', list.length);
    },
    setActivityBadges: function setActivityBadges(state, _a) {
      var activityId = _a.activityId,
          data = _a.data;
      Vue.set(state.activityBadges, activityId, data);
    },

    /** 设置勋章卡详情 */
    setDetail: function setDetail(state, _a) {
      var medalId = _a.medalId,
          detail = _a.detail;
      Vue.set(state.badgeDetails, medalId, detail);
    },
    setMyDataRequest: function setMyDataRequest(state, request) {
      state.myData.requesting = request;
    },
    setMyDataLoaded: function setMyDataLoaded(state, loaded) {
      state.myData.loaded = loaded;
    },
    concatMyData: function concatMyData(state, list) {
      state.myData.list = state.myData.list.concat(list);
    },

    /**
     * 已获得勋章
     */
    initReceived: function initReceived(state, _a) {
      var userId = _a.userId;
      Vue.set(state.received, userId, {
        list: [],
        loaded: false,
        requesting: false,
        total: 0
      });
    },
    concatReceived: function concatReceived(state, _a) {
      var _b;

      var userId = _a.userId,
          list = _a.list;

      (_b = state.received[userId].list).push.apply(_b, __spread(list));
    },
    setReceivedTotal: function setReceivedTotal(state, _a) {
      var userId = _a.userId,
          total = _a.total;
      state.received[userId].total = total;
    },
    setReceivedLoaded: function setReceivedLoaded(state, _a) {
      var userId = _a.userId,
          loaded = _a.loaded;
      state.received[userId].loaded = loaded;
    },
    setReceivedReq: function setReceivedReq(state, _a) {
      var userId = _a.userId,
          req = _a.req;
      state.received[userId].requesting = req;
    },

    /**
     * 记录当日特殊勋章
     */
    setToday: function setToday(state, today) {
      state.today = today;
    }
  },
  actions: {
    /**
     * 获取活动相关勋章
     */
    getActivityList: function getActivityList(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var offset = _b.offset,
          count = _b.count;
      return __awaiter(this, void 0, void 0, function () {
        var wrap, end, len, response, rdata, list;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              wrap = state.activityList;

              if (wrap.req || wrap.loaded) {
                return [2
                /*return*/
                ];
              }

              end = offset + count;
              len = wrap.list.length;

              if (end <= len) {
                return [2
                /*return*/
                ];
              }

              if (offset < len) {
                offset = len;
                count = end - offset;
              }

              commit('setActivityListReq', {
                req: true
              });
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/medal/activity_list', {
                params: {
                  offset: offset,
                  count: count
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                list = rdata.data;
                commit('concatActivityList', {
                  list: list
                });

                if (list.length < count) {
                  commit('setActivityListLoaded', {
                    loaded: true
                  });
                }
              }

              commit('setActivityListReq', {
                req: false
              });
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取活动相关勋章
     */
    getActivityBadges: function getActivityBadges(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId,
          userId = _b.userId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/medal/activity', {
                params: {
                  id: activityId,
                  user_id: userId
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setActivityBadges', {
                  activityId: activityId,
                  data: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取通用勋章
     */
    getCommonBadges: function getCommonBadges(_a, userId) {
      var state = _a.state,
          commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/medal/common', {
                params: {
                  user_id: userId
                }
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setCommonBadges', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取碎片勋章
     */
    getFragmentBadges: function getFragmentBadges(_a) {
      var state = _a.state,
          commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/medal/fragment')];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setFragmentBadges', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取碎片勋章
     */
    getHolidayMedals: function getHolidayMedals(_a, year) {
      var state = _a.state,
          commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/medal/holiday_medal', {
                params: {
                  offset: 0,
                  count: 300,
                  year: year
                }
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setHolidayMedals', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },
    getFinalMedal: function getFinalMedal(_a) {
      var state = _a.state,
          commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/medal/final_medal')];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setFinalMedal', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取勋章卡详情
     */
    getDetail: function getDetail(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var medalId = _b.medalId,
          userId = _b.userId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/medal/detail', {
                params: {
                  id: medalId,
                  user_id: userId
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setDetail', {
                  medalId: medalId,
                  detail: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取我的数据
     */
    getMyData: function getMyData(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var count = _b.count,
          offset = _b.offset,
          forceUpdate = _b.forceUpdate;
      return __awaiter(this, void 0, void 0, function () {
        var end, response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              if (state.myData.requesting || state.myData.loaded && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              if (offset === 0 && forceUpdate) {
                state.myData.list = [];
                state.myData.loaded = false;
                state.myData.requesting = false;
              }

              end = offset + count;

              if (end <= state.myData.list.length) {
                return [2
                /*return*/
                ];
              }

              if (offset < state.myData.list.length) {
                offset = state.myData.list.length;
                count = end - offset;
              }

              commit('setMyDataRequest', true);
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/user/week_card', {
                params: {
                  offset: offset,
                  count: count
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('concatMyData', rdata.data);

                if (rdata.data.length < count) {
                  commit('setMyDataLoaded', true);
                }
              }

              commit('setMyDataRequest', false);
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },
    getReceived: function getReceived(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var userId = _b.userId,
          offset = _b.offset,
          count = _b.count;
      return __awaiter(this, void 0, void 0, function () {
        var wrap, end, response, rdata, list;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              wrap = state.received[userId];

              if (!wrap) {
                commit('initReceived', {
                  userId: userId
                });
                wrap = state.received[userId];
              }

              if (wrap.requesting || wrap.loaded) {
                return [2
                /*return*/
                ];
              }

              end = offset + count;

              if (end <= state.myData.list.length) {
                return [2
                /*return*/
                ];
              }

              if (offset < state.myData.list.length) {
                offset = state.myData.list.length;
                count = end - offset;
              }

              commit('setReceivedReq', {
                userId: userId,
                req: true
              });
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/medal/user_medal', {
                params: {
                  user_id: userId,
                  offset: offset,
                  count: count
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                list = rdata.data.list;
                commit('concatReceived', {
                  userId: userId,
                  list: list
                });
                commit('setReceivedTotal', {
                  userId: userId,
                  total: rdata.data.total
                });

                if (list.length < count) {
                  commit('setReceivedLoaded', {
                    userId: userId,
                    loaded: true
                  });
                }
              }

              commit('setReceivedReq', {
                userId: userId,
                req: false
              });
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取当天数据
     */
    getToday: function getToday(context) {
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/medal/today_medal')];

            case 1:
              response = _a.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                context.commit('setToday', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    }
  }
};
export default m;